import { API_STATUS } from 'core-lib/constants/network';
import ip from 'icepick';
import {
  UPDATE_USER_REVIEWS,
  UPDATE_CAR_TOP_REVIEWS,
  UPDATE_DEALER_TOP_REVIEWS,
  UPDATE_CAR_RECENTLY_VIEWED,
  UPDATE_DEALER_RECENTLY_VIEWED,
  UPDATE_MOST_REVIEWED_DEALER,
  UPDATE_MOST_REVIEWED_CAR,
} from './type';
import { ReviewReducerType } from '../types';

const initialState: ReviewReducerType = ip.freeze({
  userReviews: {
    apiStatus: API_STATUS.default,
    data: [],
  },
  carTopReviews: {},
  dealerTopReviews: {},
  carRecentlyViewed: {
    apiStatus: API_STATUS.default,
    data: [],
  },
  dealerRecentlyViewed: {
    apiStatus: API_STATUS.default,
    data: [],
  },
  mostReviewedCar: {
    apiStatus: API_STATUS.default,
    data: null,
  },
  mostReviewedDealer: {
    apiStatus: API_STATUS.default,
    data: null,
  },
});

export const reviewsModule = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_CAR_TOP_REVIEWS: {
      state = ip.setIn(state, ['carTopReviews'], payload);
      return state;
    }
    case UPDATE_DEALER_TOP_REVIEWS: {
      state = ip.setIn(state, ['dealerTopReviews'], payload);
      return state;
    }
    case UPDATE_USER_REVIEWS: {
      state = ip.setIn(state, ['userReviews'], payload);
      return state;
    }
    case UPDATE_CAR_RECENTLY_VIEWED: {
      state = ip.setIn(state, ['carRecentlyViewed'], payload);
      return state;
    }
    case UPDATE_DEALER_RECENTLY_VIEWED: {
      state = ip.setIn(state, ['dealerRecentlyViewed'], payload);
      return state;
    }
    case UPDATE_MOST_REVIEWED_CAR: {
      state = ip.setIn(state, ['mostReviewedCar'], payload);
      return state;
    }
    case UPDATE_MOST_REVIEWED_DEALER: {
      state = ip.setIn(state, ['mostReviewedDealer'], payload);
      return state;
    }

    default: {
      return state;
    }
  }
};
